import { Component, Inject, ViewChild, OnInit } from '@angular/core';
import { MatSnackBar, MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource, Sort, PageEvent } from '@angular/material';
import { PropuestasService } from '../../../providers/propuestas.service';


@Component({
  selector: 'app-ordenar-estado-propuesta-dialog',
  templateUrl: './ordenar-estado-propuesta-dialog.component.html',
  styleUrls: ['./ordenar-estado-propuesta-dialog.component.scss']
})
export class OrdenEstadoPropuestaDialog implements OnInit{
  error: string = '';
  cargando: boolean = false;
  flujo_actual=1;
  tablaEstadosColumnas = ['Orden', 'Descripcion', 'OrdenActual'];
  estadosDataSource = new MatTableDataSource();
  flujos:any;
  orden_disponible : any[] = [];
  estados : any[] = [];


  filtro: string = '';

  constructor(
    public dialogEditar: MatDialogRef<OrdenEstadoPropuestaDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    public propuestaService: PropuestasService
  ) { }

  ngOnInit(): void {
    this.propuestaService.getEstadosPropuestas({'filtros':{'flujo_id':this.data.flujo.id}}).subscribe(
      respuesta => {
        if(respuesta.estado == 1){
          this.estados = respuesta.estados;
          this.estados.forEach(function (estado) {
            estado.value=false;
            // console.log('estado',estado.value);
          });
          this.estadosDataSource.data = this.estados
          this.orden_disponible = respuesta.orden_disponible;
        }
      }
    );
  }

  onCancelar(): void {
    this.dialogEditar.close();
  }

  onEditar(): void {
    this.error = '';

    let estados_a_cambiar = this.estadosDataSource.data;
    this.cargando = true;

    for(let i = 0; i < estados_a_cambiar.length; i++){
      for(let j = 0; j < estados_a_cambiar.length; j++){
        if(i != j){
          if(estados_a_cambiar[i]['orden'] == estados_a_cambiar[j]['orden']){
            this.snackBar.open("ESTADOS CON MISMO N° DE ORDEN", 'X', { duration: 2750 });
            this.cargando = false;
            this.estados[i].value = true;
            this.estados[j].value = true;
            return;
          }
        }
      }
    }

    this.propuestaService.reOrdenarEstadosPropuesta(estados_a_cambiar).subscribe(
      respuesta =>{
        if (respuesta.estado == 1) {
          this.snackBar.open(respuesta.mensaje, 'OK', { duration: 2750 });
          this.dialogEditar.close(respuesta);
        } else {
          this.error = respuesta.mensaje;
        }
        this.cargando = false;
      },
      error => {
        this.cargando = false;
        this.error = error;
      }
    )


  }

}
